import { Component, Input, OnInit } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartScales, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';

@Component({
  selector: 'app-stacked-bars-policie-reports',
  templateUrl: './stacked-bars-policie-reports.component.html',
  styleUrls: ['./stacked-bars-policie-reports.component.scss'],
})
export class StackedBarsPolicieReportsComponent implements OnInit {
  @Input() barra1: any['totalAceite'];
  @Input() barra2: any['visualizaram'];
  @Input() barra3: any['totalNaoAceite'];
  qtdUsers: number;

  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{}], yAxes: [{}] },
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 0,
        bottom: 0,
      },
    },
    tooltips: {
      enabled: true,
      mode: 'y',
      titleFontColor: 'transparent',
      titleMarginBottom: 0,
      titleFontSize: 10,
      callbacks: {
        label: function (tooltipItem, data) {
          const value = data.datasets[tooltipItem.datasetIndex].data[
            tooltipItem.index
          ] as number;

          const label = data.datasets[tooltipItem.datasetIndex].label;

          const percentage = value.toFixed(2) + '%';
          return `${label}: ${percentage}`;
        },
      },
    },
  };

  public barChartType: ChartType = 'horizontalBar';
  public barChartLegend = false;
  public display: ChartScales = { display: false };

  public chartColors: Array<any> = [
    {
      backgroundColor: '#00b050',
    },
    {
      backgroundColor: '#9bc9a5',
    },
    {
      backgroundColor: '#d0cece',
    },
  ];

  public barChartData: ChartDataSets[] = [
    {
      data: [],
      label: 'Aceitaram',
      stack: 'A',
      // maxBarThickness: 100,
      showLine: false,
    },
    {
      data: [],
      label: 'Visualizaram',
      stack: 'B',
      // maxBarThickness: 100,
      showLine: false,
    },
    {
      data: [],
      label: 'Não Aceitaram',
      stack: 'C',
      // maxBarThickness: 100,
      showLine: false,
    },
  ];
  result: number;

  ngOnInit() {
    this.customizeChartBar();
  }

  customizeChartBar() {
    this.barChartData[0].data.push(this.barra1);
    this.barChartData[1].data.push(this.barra2);
    this.barChartData[2].data.push(this.barra3);
  }
}

